import {AssessmentDataField} from './assessment-data-field.model';
import {AssessmentDataRow} from './assessment-data-row.model';

export class Assessment {

	// Properties
	id: number;
	AssessmentDataField: AssessmentDataField[];
	AssessmentsDataRows: AssessmentDataRow[];
	BESTOF: boolean;
	DESCRIPTION: string;
	Display: boolean;
	FULLTITLE: string;
	MasterId: number;
	SEQUENCE: number;
	SubTypeTestId: number;
	get Id(): number {
		return this.id;
	}
	get AssessmentDataFields(): AssessmentDataField[] {
		return this.AssessmentDataField;
	}
	get FullTitle(): string {
		return this.FULLTITLE;
	}
	get BestOf(): boolean {
		return this.BESTOF;
	}
	get Description(): string {
		return this.DESCRIPTION;
	}
	get Sequence(): number {
		return this.SEQUENCE;
	}

	// Class Functions
	constructor () {}
}

export class TestMasterLayoutVersion {
	VersionId: number;
	Description: string;
	TestMasterId: number;
	TestSubTypeId: number;
}

export class AssessmentField {
	TakenDate: Date;
	MasterName: string;
	VersionName: string;
	VersionId: number;
	TestFieldId: number;
	FieldName: string;
	FieldData: string;
	POSStart: number;
	Length: number;
	SubTypeId: number;
	FieldType: number;
	NumericDigits: number;
	NumericDecimals: number;
	MaxNumeric: number;
	PrintOnTranscript: boolean;
}
